import React, { useState, useEffect } from "react";
import { useLocation, NavLink } from "react-router-dom";
import { Divider, TextField, List, Link, Icon, Tooltip, Grid, capitalize } from "@mui/material";

import {
  useMaterialUIController,
  setMiniSidenav,
  setTransparentSidenav,
  setWhiteSidenav,
  useTranslations,
} from "context";

import { styled } from "@mui/material/styles";
import { item } from "./styles/sidenavItem";
import { BrandLogo } from "components/alove/BrandLogo";
import { getMyRolesDO, getRoleDO, getRolesDO } from "utils/rolesUtils";
import { DropdownButton } from "components/alove/DropDownButton";
import { translationsLanguagesDO } from "utils/translateUtils";
import { getNotificationsDO } from "utils/adminUtils";
import { Brand } from "models/BO/Brand";
import { MyRoute } from "routes";
import { Language } from "models/content/Language";
import { useBrands, useAuth } from 'context';


import { SidenavProps, Notifications } from "./types";
import { LanguageSelector } from "./components/LanguageSelector";
import { renderRoutes } from "./utils/renderFunctions";
import { SystemSettings } from "layouts/appSettings/system";
import { BrandManagement } from "./components/BrandManagement";

const MDTypography = require("components/MDTypography/index").default;
const SidenavItem = require("components/Sidenav/SidenavItem").default;
const SidenavList = require("components/Sidenav/SidenavList").default;
const SidenavCollapse = require("components/Sidenav/SidenavCollapse").default;
const SidenavRoot = require("components/Sidenav/SidenavRoot").default;
const sidenavLogoLabel = require("components/Sidenav/styles/sidenav").default;
const MDAvatar = require("components/MDAvatar/index").default;
const MDBox = require("components/MDBox/index").default;

function Sidenav({ color = "info", brand, brandName, routes, ...rest }: SidenavProps) {
  const [openCollapse, setOpenCollapse] = useState<string | false>(false);
  const [openNestedCollapse, setOpenNestedCollapse] = useState<string[]>([]);
  const [controller, dispatch] = useMaterialUIController();
  const { brands,setBrandById,currentBrand } = useBrands();
  const {
    miniSidenav,
    transparentSidenav,
    whiteSidenav,
    darkMode,
    auth,
    settingPages
  } = controller;
  const location = useLocation();
  const { pathname } = location;
  const collapseName = pathname.split("/").slice(1)[0];
  const items = pathname.split("/").slice(1);
  const itemParentName = items[1];
  const itemName = items[items.length - 1];
  const [notifications, setNotifications] = useState<Notifications>({});


  const { currentUser, currentRole } = useAuth();

  let textColor = "white";

  if (transparentSidenav || (whiteSidenav && !darkMode)) {
    textColor = "dark";
  } else if (whiteSidenav && darkMode) {
    textColor = "inherit";
  }

  const closeSidenav = () => setMiniSidenav(dispatch, true);

  useEffect(() => {
    getNotificationsDO().then((res) => 
      setNotifications(res))
  }, [currentBrand]);

  // useEffect(() => {
  //   // Set initial open states based on current path
  //   const pathParts = pathname.split("/").filter(Boolean);
  //   if (pathParts.length > 1) {
  //     setOpenNestedCollapse(pathParts.slice(0, -1));
  //   }
  // }, [pathname]);

  useEffect(() => {
    function handleMiniSidenav() {
      setMiniSidenav(dispatch, window.innerWidth < 1200);
      setTransparentSidenav(dispatch, window.innerWidth < 1200 ? false : transparentSidenav);
      setWhiteSidenav(dispatch, window.innerWidth < 1200 ? false : whiteSidenav);
    }

    window.addEventListener("resize", handleMiniSidenav);
    handleMiniSidenav();
    return () => window.removeEventListener("resize", handleMiniSidenav);
  }, [dispatch, location]);



  // const roleTitle = currentUser?.role?.[currentBrand?.id]?.roles
  //   ?.map((item: number) => roles?.find((role) => role?.id === item)?.roleName)
  //   .join(", ");
  //   const route = routes.find((route) => route.key === "settings");
  //   if (route && route.collapse && settingPages.length > 0) {
  //     route.collapse = settingPages.map((page) => ({
  //       name: page.title,
  //       key: page.id,
  //       route: `/brandSettings/${page.id}`,
  //       accessNumber: 0,
  //       component: <SystemSettings pageId={page.id} />,
  //     }));
  //   }
  return (
    <SidenavRoot
      {...rest}
      variant="permanent"
      style={{ zIndex: 500, position: "absolute" }}
      ownerState={{ transparentSidenav, whiteSidenav, miniSidenav, darkMode }}
    >
      <MDBox pt={2} pb={1} textAlign="center">
        <MDBox
          display={{ xs: "block", xl: "none" }}
          position="absolute"
          top={0}
          right={0}
          p={1.625}
          onClick={closeSidenav}
          sx={{ cursor: "pointer" }}
        >
          <MDTypography variant="h6" color="secondary">
            <Icon sx={{ fontWeight: "bold" }}>close</Icon>
          </MDTypography>
        </MDBox>

        <MDBox display="flex" alignItems="start" sx={(theme) => item(theme, { active: false })}>
          <MDBox sx={{ mt: 2 }}>
            {currentBrand && <BrandLogo brand={currentBrand} />}
          </MDBox>

<Grid container sx={{ml:2}} gap={1}>
            <BrandManagement
            />
            <LanguageSelector
            />
          </Grid>
        </MDBox>
      </MDBox>

      <Divider
        sx={{ mx: 2, my: 1 }}
        style={{
          color: "white",
          borderStyle: "dotted",
          borderWidth: "2px",
        }}
      />
      {currentRole ? (
        <List>
          {renderRoutes(
            routes,
            color,
            pathname,
            openCollapse,
            setOpenCollapse,
            openNestedCollapse,
            setOpenNestedCollapse,
            currentRole,
            notifications,
            currentUser,
            textColor
          )}
        </List>
      ) : null}
    </SidenavRoot>
  );
}

export default Sidenav; 